/**
 * @since 2016-01-28 16:36
 * @author vivaxy
 */

'use strict';

var MIDAS_COOKIE = 'midasclick';
var scrollDelay;

var IN_SCREEN_HEIGHT = 50;
var IN_SCREEN_WIDTH = 50;
var sendView = true;
var stopClickPropagation = true;
var stopScrollPropagation = true;

var setCookie = function (name, value) {
    var domain = '';
    if (location.host.indexOf('dianping') !== -1) {
        domain = 'dianping.com';
    } else {
        domain = '51ping.com';
    }
    // 设置 domain 为了使 m.dianping.com 写入的 cookie 能够在 evt.dianping.com 等不同二级域名下读取到
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/' + '; domain=' + domain;
};

var getElementArray = function () {
    return document.querySelectorAll('[data-midas]');
};

var getParentsAttr = function (ele, attr) {
    var data;
    var eleParent = ele.parentNode;

    while (eleParent.nodeName == 'BODY' && !eleParent.getAttribute(attr)) {
        eleParent = eleParent.parentNode;
    }
    data = eleParent.getAttribute(attr);

    return data;
};

var bindClickEvent = function (ele, fn) {
    ele.addEventListener('click', fn);
};

var sendMidas = function (data, act) {
    var url = '';

    if (data) {
        if (data.indexOf('?') > -1) {
            url = data;
        } else {
            var host = window.location.host;
            if (host.indexOf('dianping.com') > -1 && !/^ppe/.test(host)) {
                url = location.protocol + '//mlog.dianping.com/log?';
            } else if (host.indexOf('meituan.com') > -1 && !/test/.test(host)) {
                url = location.protocol + '//mlog.dianping.com/log?';
            } else {
                url = location.protocol + '//mlog.51ping.com/log?';
            }
            url = url + decodeURIComponent(data);
        }

        url = url + '&act=' + act + '&referer=' + encodeURIComponent(document.referrer) + '&t=' + new Date().getTime();
        send(url);
    }
};

var sendMidasClick = function (data, clickUrl) {
    sendMidas(data, 2);
    clickUrl && send(clickUrl);
};

var send = function (url) {
    // todo use global variable to save image
    // todo use queue
    var image = new Image(1, 1);
    image.onload = image.onerror = function () {
        image = null;
    };
    image.src = url;
};

var stopBubble = function (e) {
    if (e && e.stopPropagation) {
        e.stopPropagation();
    } else {
        window.event.cancelBubble = true;
    }
};

var clickAction = function (e) {

    var ele = this;
    var selfMidasData = ele.getAttribute('data-midas');
    var clickUrl = ele.getAttribute('data-clickurl');

    if (stopClickPropagation) {
        stopBubble(e);
    }

    if (ele.getAttribute('data-inner-jump')) { // 本页跳转，打点数据存入cookie, 用于移动端，点击区域为整个模块
        setCookie(MIDAS_COOKIE, selfMidasData + '&referer=' + encodeURIComponent(document.referrer) + '|' + (clickUrl ? clickUrl : ''));
        window.location.href = ele.getAttribute('data-linkurl');
    } else { //新开页

        var cur = e.target;
        // cur 实际点击的元素，this 事件绑定的元素
        // curMidasData = cur.getAttribute('data-midas'),
        var curMidasExtendData = cur.getAttribute('data-midas-extends');
        var curClickUrl = ele.getAttribute('data-clickurl');

        // if (ele.nodeName === 'A') { // 广告所有部位可点击
        //     sendMidasClick(selfMidasData, curClickUrl);
        // } else {
        //     if (curMidasExtendData) { // 点击部位是广告模块
        //         sendMidasClick(selfMidasData + '&' + curMidasExtendData, curClickUrl);
        //     } else { // 点击部位是广告模块内元素
        //         var midasExtendData = getParentsAttr(cur, 'data-midas-extends');
        //         if (midasExtendData) {
        //             sendMidasClick(selfMidasData + '&' + midasExtendData, curClickUrl);
        //         } else {
        //             sendMidasClick(selfMidasData, curClickUrl);
        //         }
        //     }
        // }

        var resultMidasData = selfMidasData;
        if (curMidasExtendData) {
            resultMidasData = selfMidasData + '&' + curMidasExtendData;
        } else {
            var midasExtendData = getParentsAttr(cur, 'data-midas-extends');
            if (midasExtendData) {
                resultMidasData = selfMidasData + '&' + midasExtendData;
            }
        }
        sendMidasClick(resultMidasData, curClickUrl);

    }

};

// 测试重点：
//  1. 支持配置出现在屏幕中多少像素算是在屏幕中
//  2. 兼容整个元素的宽高小于设置的像素的情况
//  3. 兼容元素尺寸大于屏幕尺寸的
//  4. 兼容性
var isOnScreen = function (element) {

    var rect = element.getBoundingClientRect();

    if (rect.width === 0 || rect.height === 0 || element.style.opacity === '0') {
        return false;
    }

    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;

    var elementHeight = element.offsetHeight;
    var elementWidth = element.offsetWidth;

    var onScreenHeight = IN_SCREEN_HEIGHT > elementHeight ? elementHeight : IN_SCREEN_HEIGHT;
    var onScreenWidth = IN_SCREEN_WIDTH > elementWidth ? elementWidth : IN_SCREEN_WIDTH;

    // 元素在屏幕上方
    var elementBottomToWindowTop = rect.top + elementHeight;
    var bottomBoundingOnScreen = elementBottomToWindowTop >= onScreenHeight;

    // 元素在屏幕下方
    var elementTopToWindowBottom = windowHeight - (rect.bottom - elementHeight);
    var topBoundingOnScreen = elementTopToWindowBottom >= onScreenHeight;

    // 元素在屏幕左侧
    var elementRightToWindowLeft = rect.left + elementWidth;
    var rightBoundingOnScreen = elementRightToWindowLeft >= onScreenWidth;

    // 元素在屏幕右侧
    var elementLeftToWindowRight = windowWidth - (rect.right - elementWidth);
    var leftBoundingOnScreen = elementLeftToWindowRight >= onScreenWidth;

    return bottomBoundingOnScreen && topBoundingOnScreen && rightBoundingOnScreen && leftBoundingOnScreen;
};

var sendMidasImpression = function () {
    var ads = getElementArray();

    for (var i = 0, j = ads.length; i < j; i++) {
        var ad = ads[i];
        var data = ad.getAttribute('data-midas');
        var impressionUrl = ad.getAttribute('data-impressionurl');

        var isInScreen = isOnScreen(ad);

        if (isInScreen && !ad.getAttribute('data-midas-impressed')) {
            sendMidas(data, 3);
            impressionUrl && send(impressionUrl);
            ad.setAttribute('data-midas-impressed', 'true');
        }
    }
};

var initScrollAction = function (e) {

    if (stopScrollPropagation) {
        stopBubble(e);
    }
    clearTimeout(scrollDelay);
    scrollDelay = setTimeout(function () {
        sendMidasImpression();
    }, 200);
};

module.exports = {

    init: function (settings) {

        if (settings) {
            this.config(settings);
        }

        if (sendView) {
            this.view();
        }

        this.initClick();
        this.initImpression();

        var scroll = new Event('scroll');
        window.dispatchEvent(scroll);

        this.reach();

    },

    config: function (settings) {
        if (settings.inScreenHeight !== undefined) {
            if (typeof settings.inScreenHeight === 'number' && settings.inScreenHeight >= 0) {
                IN_SCREEN_HEIGHT = settings.inScreenHeight;
            }
        }
        if (settings.inScreenWidth !== undefined) {
            if (typeof settings.inScreenWidth === 'number' && settings.inScreenWidth >= 0) {
                IN_SCREEN_WIDTH = settings.inScreenWidth;
            }
        }
        if (settings.sendView !== undefined) {
            if (typeof settings.sendView === 'boolean') {
                sendView = settings.sendView;
            }
        }
        if (settings.stopClickPropagation !== undefined) {
            if (typeof settings.stopClickPropagation === 'boolean') {
                stopClickPropagation = settings.stopClickPropagation;
            }
        }
        if (settings.stopScrollPropagation !== undefined) {
            if (typeof settings.stopScrollPropagation === 'boolean') {
                stopScrollPropagation = settings.stopScrollPropagation;
            }
        }
    },

    view: function () {

        var ads = getElementArray();

        for (var i = 0, j = ads.length; i < j; i++) {

            var ad = ads[i];
            var data = ad.getAttribute('data-midas');
            var pvUrl = ad.getAttribute('data-pvurl'); // 第三方pv打点
            var isViewed = ad.getAttribute('data-viewed');

            if (!isViewed) {
                sendMidas(data, 1);
                pvUrl && send(pvUrl);
                ad.setAttribute('data-viewed', 'true');
            }
        }
    },

    initImpression: function () {
        if (window.attachEvent) {
            window.attachEvent('onscroll', initScrollAction);
        } else {
            window.addEventListener('scroll', initScrollAction, false);
        }
    },

    impression: function () {
        sendMidasImpression();
    },

    initClick: function () {
        var ads = getElementArray();
        for (var i = 0, j = ads.length; i < j; i++) {

            var ad = ads[i];
            var data = ad.getAttribute('data-midas');
            var isBinded = ad.getAttribute('data-click-inited');

            if (!isBinded) {
                bindClickEvent(ad, clickAction);
                ad.setAttribute('data-click-inited', 'true');
            }
        }

    },

    reach: function () {
        // reach 点是 iframe 发送的，hippo 用来做离线分析
        var locSearch = location.search.slice(1);
        var hipObj = {};
        var locQuery, query, qs, i = 0;
        if (locSearch.indexOf('feedback') > -1 || locSearch.indexOf('_fb_') > -1) {
            locSearch.indexOf('feedback') > -1 && (locQuery = locSearch.split('feedback='));
            locSearch.indexOf('_fb_') > -1 && (locQuery = locSearch.split('_fb_='));

            query = locQuery[locQuery.length - 1];
            query = query.indexOf('&') > -1 ? decodeURIComponent(query.split('&')[0]) : decodeURIComponent(query);
            qs = query.split('&');
            for (i; i < qs.length; i += 1) {
                var split = qs[i].split('=');
                if (split.length == 2) {
                    hipObj[split[0]] = split[1]
                }
            }
            if (_hip && _hip.push) {
                _hip.push(['mv', hipObj]);
            }
        }
    }

};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/m-midas-log/js/entry/index.js
// module id = 293
// module chunks = 0 8 9